import { SVGProps } from "react";

// The Axle "A" mark from the design guide (axle-a-mark.svg): black disc, white A.
// Exact paths; never redraw, recolor beyond black and white, or stretch it.
export const AxleMark = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 96 96" role="img" aria-label="Axle" {...props}>
    <path
      d="M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z"
      fill="#000000"
    />
    <path
      fillRule="evenodd"
      d="M44.46 30L31.5 64.2721H39.084L41.772 56.64H54.588L57.18 64.2721H65.004L52.188 30H44.46ZM43.74 51.0241L48.204 38.4481H48.3L52.62 51.0241H43.74Z"
      fill="#FFFFFF"
    />
  </svg>
);
